export const messages = {
  en: {
    historyFeeDetailImport: {
      assetInfo: 'Asset Information',
      feeObject: 'Fee Object',
      selectFeeObject: 'Required, please select fee object',
      house: 'House',
      car: 'Car',
      selectFile: 'Select File',
      requiredFile: 'Required, please select data file',
      clickUpload: 'Click to upload',
      description: 'Description',
      importTip: 'Note: This is for importing historical payment data from previous property systems to facilitate future accounting checks. It should only be used during property data initialization. Please carefully check the data before importing. Once imported, payment history cannot be deleted from the frontend and can only be removed by engineers from the database.',
      import: 'Import',
      houseTemplate: 'House Template',
      carTemplate: 'Car Template',
      fileRequired: 'File is required',
      invalidFileType: 'Invalid file type, only Excel files are allowed',
      fileSizeLimit: 'File size cannot exceed 2MB',
      importSuccess: 'Import successful',
      importError: 'Import failed',
      requiredSelect: 'Required, please select'
    }
  },
  zh: {
    historyFeeDetailImport: {
      assetInfo: '资产信息',
      feeObject: '费用对象',
      selectFeeObject: '必填，请选择费用对象',
      house: '房屋',
      car: '车辆',
      selectFile: '选择文件',
      requiredFile: '必填，请选择数据文件',
      clickUpload: '点击上传',
      description: '说明',
      importTip: '请注意，这里是为了将物业之前系统缴费历史数据导入，方便物业后期查账使用，只有在物业数据初始化时使用，导入前请仔细检查数据，一旦导入前台无法删除缴费历史，只有工程师从数据库删除',
      import: '导入',
      houseTemplate: '房屋模板',
      carTemplate: '车辆模板',
      fileRequired: '文件不能为空',
      invalidFileType: '不是有效的Excel格式',
      fileSizeLimit: 'Excel文件大小不能超过2M',
      importSuccess: '处理成功',
      importError: '导入失败',
      requiredSelect: '必填，请选择'
    }
  }
}